module.exports = __webpack_public_path__ + "static/media/speaker-xianyou.3e630701.jpg";